import React, { useRef, useState } from "react";
import styles from "./EditProfile.module.css";
import dummyImg from "../../assets/images/staticImages/profile.png";
import { useNavigate } from "react-router-dom";
import {
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../components";
import { IoChevronBackOutline } from "react-icons/io5";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import { FaCamera } from "react-icons/fa";

const EditProfile = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [FName, setFName] = useState("");
  const [LName, setLname] = useState("");

  const [contactNo, setContactNo] = useState("");
  const [profileImg, setProfileImg] = useState(null);

  const hiddenPFInput = useRef();
  const handlePFHandler = () => {
    hiddenPFInput.current.click();
  };

  return (
    <div className={styles.mainCon}>
      <HeaderComponent  showBackIcon={true} heading={"Edit Profile"}  />

      <div className={styles.SubMainCont}>
        <div className={styles.centerDiv}>
          <div className={styles.imgCont} onClick={handlePFHandler}>
            <img src={profileImg ? URL.createObjectURL(profileImg) : dummyImg} />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImg(e.target.files[0])}
              ref={hiddenPFInput}
              style={{ display: "none" }}
            />
            <FaCamera className={styles.cameraIcon} />
          </div>
          <TextComponent text={"Personal Details"} className={styles.title} />
          <InputField
            className={styles.input}
            labelClass={styles.labelClass}
            label={"First Name"}
            placeholder={"Stacy"}
            value={FName}
            onChange={(e) => setFName(e.target.value)}
          />
          <InputField
            className={styles.input}
            labelClass={styles.labelClass}
            label={"Last Name"}
            placeholder={"Doe"}
            value={LName}
            onChange={(e) => setLname(e.target.value)}
          />
          <InputField
            className={styles.input}
            labelClass={styles.labelClass}
            label={"Email Address"}
            placeholder={"StacyDoe@gmail.com"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <PhoneInput
            label={"Phone Number"}
            labelClass={styles.labelClass}
            placeholder={"(504) 896-6913"}
            inputStyle={{
              border: "1.5px solid #E8ECF4 ",

              backgroundColor: "#F7F8F9",
            }}
            className={styles.input}
            value={contactNo}
            maxLength={10}
            onChange={(e) => setContactNo(e.target.value)}
          />
          <div className={styles.BtnDiv}>
            <SubmitButton
              style={{ width: "400px", marginTop: "20px" }}
              title={"Save"}
              onClick={() => navigate("/Profile")}
              btnContainerClass={styles.btnContainer}
              primary
              btnClass={`${styles.btn}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
